module.exports = __webpack_public_path__ + "img/download-dashboard.d5ceaa8d.svg";